/* eslint-disable ember/no-computed-properties-in-native-classes */
import Post from './post';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import {
  hasMany,
  belongsTo,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import type Event from '@linc-technologies/linced-common/models/events/event';
import type Media from 'linced-app/models/media';
import type Comment from 'linced-app/models/posts/comment';
import type Reaction from 'linced-app/models/posts/reaction';

// Proto: posts.Post.
export default class Staffnotice extends Post {
  declare [Type]: 'posts/staffnotice';

  postType = PostTypes.STAFF_NOTICE;

  @hasMany('posts/comment', { async: true, inverse: 'staffNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse staffNoticeId).
  declare comments: AsyncHasMany<Comment>;

  @hasMany('posts/reaction', { async: true, inverse: 'staffNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse staffNoticeId).
  declare reactions: AsyncHasMany<Reaction>;

  @hasMany('media', { async: true, inverse: 'staffNoticeId' })
  // @ts-expect-error the app models replace the common ones
  // (inverse staffNoticeId).
  declare mediaIds: AsyncHasMany<Media>;

  @belongsTo('events/event', { async: true, inverse: 'staffNotices' })
  declare eventId: AsyncBelongsTo<Event>;

  @alias('eventId')
  declare event: AsyncBelongsTo<Event>;

  // Don't trigger the Person reloads which the base Post model does.
  reloadPersonOnSave = false;
}
